import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { map, catchError, finalize } from 'rxjs/operators';
import { StorageService } from '../services/storage.service';
import { NotificationComponent } from 'src/app/shared/layouts/notification/notification.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { LoginService } from '../services/login.service';
import { AuthService } from '../services/auth.service';
import { CommonHttpService } from '../services/common-http.service';


@Injectable()
export class CommonHttpInterceptor implements HttpInterceptor {
  modalRef!: BsModalRef;
  isArabic!: boolean;
  private excludedUrls = [
    '/login',
    '/checkServerStatus',
    '/saml/acs',
    '/sso/result',
    '/uaepass',
    '/config'
  ];
  constructor(
    public router: Router,
    private storageService: StorageService, private modalService: BsModalService,
    private loginService: LoginService, private _commonHttpService: CommonHttpService
  ) {
    this.isArabic = this.storageService.getSessionStorageData('isArabic');
  }

  intercept(httpReq: HttpRequest<any>, next: HttpHandler): Observable<any> {
    this._commonHttpService.setLoading(true);

    const isExcluded = this.excludedUrls.some(url => httpReq.url.includes(url));

    if (!isExcluded) {
      const token = localStorage.getItem('auth_token');

      if (token) {
        httpReq = httpReq.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`
          }
        });
      }
    }

    return next.handle(httpReq)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          let errorMsg = '';
          if (error.error instanceof ErrorEvent) {
            //console.log('this is client side error');
            //   errorMsg = `Error: ${error.error.message}`;
          }
          else {
            //console.log('this is server side error: ', error);
            if (error.status === 401) {
              localStorage.removeItem('auth_token');
              this.loginService.logoutUser();
              let message = this.isArabic ? 'انتهت صلاحية الجلسة. يرجى تسجيل الدخول مرة أخرى.' : 'Session expired. Please login again.';
              const initialState = { message: message, redirectTo: 'login', cancelButton: false };
              this.modalRef = this.modalService.show(NotificationComponent, { ignoreBackdropClick: true, initialState });
              return throwError('Session expired');
            }
            // NEW: Handle 403 Forbidden — BOLA / access denied 
            if (error.status === 403) {
              let message = this.isArabic ? 'ليس لديك صلاحية للوصول إلى هذا المورد.' : 'You do not have permission to access this resource.';
              const initialState = { message: message, redirectTo: '', cancelButton: false };
              this.modalRef = this.modalService.show(NotificationComponent, { ignoreBackdropClick: true, initialState });
              return throwError('Access denied');
            }

            if (error.status === 500) {
              // console.log("error login fail", error)
              if (error.error?.body?.error == 'Login Server Error') {
                this.showServerDownPopup();
                return throwError(error?.error);

              }
              return throwError(error?.error);
            } else if (error.status === 0) {
              // this.router.navigate(['/server-unavailable']);
              this.showServerDownPopup();
              return throwError('Server Down!!');
            }

          }
          //console.log(errorMsg);
          return throwError(errorMsg);
        }),
        finalize(() => this._commonHttpService.setLoading(false))
      )

  }

  showServerDownPopup() {
    // this.router.navigate(['/login']);
    // this.storageService.clearAllSessionStorageData();
    // this.loginService.clearServerInterval();
    this.loginService.logoutUser();
    let pathUrl = 'login';
    let message = this.isArabic ? 'من فضلك حاول مرة أخرى بعد بعض من الوقت' : 'Please try again after some time.';
    const initialState = {
      message: message,
      redirectTo: pathUrl,
      cancelButton: false
    };
    this.modalRef = this.modalService.show(NotificationComponent, { ignoreBackdropClick: true, initialState });
  }
}

